export const theme = {
  bannerProfile: "/commons/bg_profile_2.png",
  bannerAdmin: "/commons/bg_profile_2.png",
  bannerModal: "/commons/bg_profile_2.png",
  bannerCatalog: "/commons/layer-header-1.png",
  bannerTabsModal: "/commons/layer-header-1.png",
  bannerReport: "/commons/bg_profile_2.png",

  defaultBrand: "/commons/lista-de-asistentes.svg",
  defaultReport: "/commons/grafico.svg",

  btnSimple: {
    background: "#F2A48FCC", //color principal de la marca
    textColor: "#FBFBFBF9",
    hoverColor: "#F2A48FCC", //color principal de la marca
    borderColor: "#F2A48FCC", //color principal de la marca
  },
  primary: "#F2A48FCC", //color principal de la marca
  claro: {
    background: "#FFFFFF",
    btn: {
      primary: {
        background: "#F2A48FCC", //color principal de la marca
        textColor: "#FBFBFBF9",
        hoverColor: "#F2A48FCC", //color principal de la marca
        borderColor: "#F2A48FCC", //color principal de la marca
      },
      secondary: {},
      terciario: {},
    },
    header: {
      background: "#F8F8F8",
      textColor: "#707070",
      hoverColor: "#3C3B39",
      textApp: "#707070",
      gridHeader: "#F2A48FCC", //color principal de la marca
      gridTextHeader: "#F8F8F8",
    },
    context: {
      background: "#F8F8F8",
      backgroundItem: "#FBFBFBF9",
      textColor: "#707070",
      badgeColor: "#707070",
      textHoverColor: "#FBFBFBF9",
    },
    menuLateralTheme: {
      textColor: "#707070",
      bgColor: "#F8F8F8",
      hoverColor: "",
      itemColor: "",
      headBg: "#F2A48FCC", //color principal de la marca
    },
    catalogs: {
      textTitleColor: "#FBFBFBF9",
      textColor: "#707070",
      background: "#F8F8F8",
      backgroundItem: "#FBFBFBF9",
      context: "#F2A48FCC", //color principal de la marca
      item: "#e6e6e6",
    },
  },
  oscuro: {
    background: "#3C3B39",
    btn: {
      primary: {
        background: "#F2A48FCC", //color principal de la marca
        textColor: "#FBFBFBF9",
        hoverColor: "#F2A48FCC", //color principal de la marca
        borderColor: "#F2A48FCC", //color principal de la marca
      },
      secondary: {},
      terciario: {},
    },
    header: {
      background: "#3C3B39",
      textColor: "#FFFFFFCC",
      hoverColor: "#3C3B39",
      textApp: "#FFFFFFCC",
      gridHeader: "#F2A48FCC", //color principal de la marca
      gridTextHeader: "#F8F8F8",
    },
    context: {
      background: "#3C3B39",
      backgroundItem: "#Cecccc",
      textColor: "#3C3B39",
      badgeColor: "#707070",
      textHoverColor: "#FBFBFBF9",
    },
    menuLateralTheme: {
      textColor: "#FFFFFFCC",
      bgColor: "#3C3B39",
      hoverColor: "#00000029",
      itemColor: "#3C3B39",
      headBg: "#F2A48FCC", //color principal de la marca
      headTextColor: "#000",
    },
    catalogs: {
      textTitleColor: "#FBFBFBF9",
      textColor: "#FFFFFFCC",
      background: "#3C3B39",
      backgroundItem: "#E4E4E4",
      context: "#F2A48FCC",
      item: "#e6e6e6",
    },
  },
};

export const theme_marcados = {
  bannerProfile: "/commons/layer1.png",
  bannerAdmin: "/commons/layer1.png",
  bannerModal: "/commons/layer1.png",
  bannerCatalog: "/commons/layer1.png",
  bannerTabsModal: "/commons/layer1.png",
  bannerReport: "/commons/layer1.png",

  defaultBrand: "/commons/lista-de-asistentes.svg",
  defaultReport: "/commons/grafico.svg",

  btnSimple: {
    background: "#81C8B9CC",
    textColor: "#FBFBFBF9",
    hoverColor: "#81C8B9CC",
    borderColor: "#81C8B9CC",
  },
  primary: "#81C8B9CC",
  claro: {
    background: "#FFFFFF",
    btn: {
      primary: {
        background: "#81C8B9CC",
        textColor: "#FBFBFBF9",
        hoverColor: "#81C8B9CC",
        borderColor: "#81C8B9CC",
      },
      secondary: {},
      terciario: {},
    },
    header: {
      background: "#F8F8F8",
      textColor: "#707070",
      hoverColor: "#3C3B39",
      textApp: "#707070",
      gridHeader: "#81C8B9CC",
      gridTextHeader: "#F8F8F8",
    },
    context: {
      background: "#F8F8F8",
      backgroundItem: "#FBFBFBF9",
      textColor: "#707070",
      badgeColor: "#707070",
      textHoverColor: "#FBFBFBF9",
    },
    menuLateralTheme: {
      textColor: "#707070",
      bgColor: "#F8F8F8",
      hoverColor: "",
      itemColor: "",
      headBg: "#81C8B9CC",
    },
    catalogs: {
      textTitleColor: "#FBFBFBF9",
      textColor: "#707070",
      background: "#F8F8F8",
      backgroundItem: "#FBFBFBF9",
      context: "#81C8B9CC",
      item: "#e6e6e6",
    },
  },
  oscuro: {
    background: "#3C3B39",
    btn: {
      primary: {
        background: "#81C8B9CC",
        textColor: "#FBFBFBF9",
        hoverColor: "#81C8B9CC",
        borderColor: "#81C8B9CC",
      },
      secondary: {},
      terciario: {},
    },
    header: {
      background: "#3C3B39",
      textColor: "#FFFFFFCC",
      hoverColor: "#3C3B39",
      textApp: "#FFFFFFCC",
      gridHeader: "#81C8B9CC",
      gridTextHeader: "#F8F8F8",
    },
    context: {
      background: "#3C3B39",
      backgroundItem: "#a3a2a2",
      textColor: "#3C3B39",
      badgeColor: "#707070",
      textHoverColor: "#FBFBFBF9",
    },
    menuLateralTheme: {
      textColor: "#FFFFFFCC",
      bgColor: "#3C3B39",
      hoverColor: "#00000029",
      itemColor: "#3C3B39",
      headBg: "#81C8B9CC",
      headTextColor: "#000",
    },
    catalogs: {
      textTitleColor: "#FBFBFBF9",
      textColor: "#FFFFFFCC",
      background: "#3C3B39",
      backgroundItem: "#E4E4E4",
      context: "#81C8B9CC",
      item: "#e6e6e6",
    },
  },
};
